module.exports = __webpack_public_path__ + "img/canada-endocrine-nutritional-metabolic-diseases-female.44fd27c7.png";